import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConfig } from '../helpers/app.config';
import { Invitation } from '../models/invitation.model';
import { Pagination } from '../models/pagination.model';
import { fromInvitationsSearch } from '../reducers/invitations-search.reducer';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class TestSearchService {

  constructor(
    private store: Store,
    private httpClient: HttpClient,
    private utilsService: UtilsService,
  ) { }

  search(page: number, officeId: number, clientId: number): Observable<Pagination<Invitation>> {

    if (page === undefined) {
      page = 1;
    }

    return this.store.pipe(select(fromInvitationsSearch.selectInvitationsSearchState), switchMap(invitationSearch => {
      const cleanInvitationSearch: any = {};
      for (const key in invitationSearch) {
        if (invitationSearch[key] && key !== 'type') {
          cleanInvitationSearch[key] = invitationSearch[key];
          if (key === 'email') {
            cleanInvitationSearch[key] = encodeURIComponent(invitationSearch[key]);
          }
        }
      }

      if (invitationSearch.status) {
        cleanInvitationSearch.status = invitationSearch.status;
      }

      // https://global-jira.randstadservices.com/browse/ESFBITE-301
      // Si no mandamos periodo en la búsqueda, es que ha marcado la opción 'Todos'. Ahí si mandamos la búsqueda sobre ADN.
      // INICIO: ESFBITE-301 - 'En la pantalla de búsqueda de pruebas, modificar la petición cuando el periodo de tiempo no es "todos"'
      if (!invitationSearch.period) {
        cleanInvitationSearch.adnSearch = 1;
      }
      // FIN: ESFBITE-301

      // Agregamos origin para la búsqueda de pruebas.
      cleanInvitationSearch.origin = 'ct';

      return this.httpClient.get<Pagination<Invitation>>(AppConfig.settings.API + '/tests',
        { params: { ...cleanInvitationSearch, page, consultantOfficeId: officeId.toString(), clientId } }
      );
    }));
  }

  searchTestsFromInvitation(invitationId, officeId: number): Observable<Pagination<Invitation>> {
    return this.httpClient.get<Pagination<Invitation>>(AppConfig.settings.API + '/tests',
      {
        params: {
          invitationId, adnSearch: '0', page: '1', rows: '20', consultantOfficeId: officeId.toString(), origin: 'ct'
        }
      }
    );
  }
}
